import { type Role, type Collaborator } from 'core'
import { createState } from 'shared'

export const DEFAULT_SELECT_VALUE = '0'

const memberEmailStateContainer = createState('')
const membersStateContainer = createState<Collaborator[]>([])
const rolesStateContainer = createState<Role[]>([
	{
		label: 'Maintainer',
		value: 'maintainer'
	}
])
const rolSelectedStateContainer = createState(DEFAULT_SELECT_VALUE)
const formErrorsStateContainer = createState<
	Record<string, string | undefined>
>({})

export const memberEmailState = memberEmailStateContainer.state
export const membersState = membersStateContainer.state
export const formErrors = formErrorsStateContainer.state
export const rolesState = rolesStateContainer.state
export const rolSelectedState = rolSelectedStateContainer.state

export const setMemberEmail = (email: string) => {
	memberEmailStateContainer.updateState(() => email)
}

export const setMemberRole = (_: string, value: string) => {
	rolSelectedStateContainer.updateState(() => value)
}

export const resetFormAndErrors = () => {
	memberEmailStateContainer.updateState(() => '')
	rolSelectedStateContainer.updateState(() => '0')
	formErrorsStateContainer.updateState(() => ({}))
}
